import { render } from "./NeobuqShipsTable.vue?vue&type=template&id=75111874&scoped=true"
import script from "./NeobuqShipsTable.vue?vue&type=script&lang=js"
export * from "./NeobuqShipsTable.vue?vue&type=script&lang=js"

import "./NeobuqShipsTable.vue?vue&type=style&index=0&id=75111874&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75111874"]])

export default __exports__